import * as React from "react";
import { Notification } from "@/components/admin/notification";
import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";

export const Layout = ({ children }: React.PropsWithChildren) => {
  const { darkModeLogo, title } = useConfigurationContext();

  return (
    <div className="min-h-screen flex">
      <div className="container relative grid flex-col items-center justify-center sm:max-w-none lg:grid-cols-2 lg:px-0">
        {/* design-system.md section 4: navy brand panel, matching the same
            treatment as LoginPage's desktop split. */}
        <div className="relative hidden h-full flex-col bg-sidebar p-10 text-sidebar-foreground lg:flex">
          <div className="relative z-20 flex items-center text-lg font-medium">
            <img className="h-6 mr-2" src={darkModeLogo} alt={title} />
            {title}
          </div>
        </div>
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            {/* The Almikia mark, visible on mobile where the navy panel
                above is hidden. */}
            <div className="flex items-center justify-center gap-2 lg:hidden">
              <img className="h-6" src={darkModeLogo} alt={title} />
            </div>
            {children}
          </div>
        </div>
      </div>
      <Notification />
    </div>
  );
};
